// src/store/periodoStore.js
import { ref } from 'vue'
 
export const periodoSelecionadoPhp = ref('24') 
export const periodoSelecionadoRevenda = ref('24') 
export const periodoSelecionadoNode = ref('12') 
export const periodoSelecionadoSpring = ref('12') 
export const periodoSelecionadoJava = ref('12') 
export const periodoSelecionadoVpsLinux = ref('12') 
export const periodoSelecionadoVpsCpanel = ref('12') 
export const periodoSelecionadoVpsIcp = ref('12') 
export const periodoSelecionadoDedicado = ref('12') 